<div class="dialog-container">
  <div class="dialog-header">
    <mat-icon>search</mat-icon>
    <h2 mat-dialog-title>Pesquisa de Postos</h2>
    <button mat-icon-button mat-dialog-close class="close-button" matTooltip="Fechar diálogo">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="search-form-container">
      <form [formGroup]="formSearch" autocomplete="off">
        <div class="search-form-row">
          <div class="form-fields">
            <mat-form-field appearance="outline" class="search-field-type">
              <mat-label>Tipo:</mat-label>
              <mat-select [(ngModel)]="postoSelected" formControlName="paramType" (blur)="enableButton()">
                <mat-option value="codPosto">Código Posto</mat-option>
                <mat-option value="nomePosto">Nome Posto</mat-option>
                <!--<mat-option value="razaoSocial">Razão Social</mat-option>-->
                <!--<mat-option value="numCnpj">CNPJ</mat-option>-->
              </mat-select>
              <mat-error *ngIf="formSearch.get('paramType')?.hasError('required')">
                Informe ao menos um tipo para a consulta!
              </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline" class="search-field-value">
              <mat-label>Parâmetro:</mat-label>
              <input matInput #message formControlName="paramValue">
              <mat-error *ngIf="formSearch.get('paramValue')?.hasError('required')">
                Parâmetro é obrigatório!
              </mat-error>
            </mat-form-field>
          </div>

          <div>
            <button
              mat-button
              class="btn-fundo-vermelho" (click)="search()"
                  [disabled]="formSearch.get('paramValue')?.invalid">
               Filtrar
               <mat-icon>search</mat-icon>
            </button>
            <button
              mat-button
              class="btn-fundo-claro" mat-stroked-button (click)="clean()"
                  [disabled]="disabledButton">
                Cancelar
               <mat-icon>clear</mat-icon>
            </button>
<!--            <button mat-flat-button type="button" class="btn-export-excel" (click)="exportTOExcel()"-->
<!--                    [disabled]="selection.selected.length === 0">-->
<!--              <mat-icon>description</mat-icon>-->
<!--            </button>-->

          </div>
        </div>
      </form>
    </div>

    <!-- Barra de progresso durante a busca -->
    <div *ngIf="isLoading" class="progress-container">
      <mat-progress-bar mode="indeterminate" class="loading-progress"></mat-progress-bar>
    </div>

    <!-- Mensagem quando não há resultados -->
    <div class="alert-message" *ngIf="!isLoading && hiddenAlert === false">
      <mat-icon color="warn">info</mat-icon>
      <span>Nenhum posto encontrado com os critérios informados.</span>
    </div>

    <div class="acoes-exportar-excel">
      <button mat-button type="button" class="btn-fundo-claro" (click)="exportTOExcel()"
        [disabled]="selection.selected.length === 0">
        <span> Exportar Excel </span>
        <mat-icon>description</mat-icon>
      </button>
    </div>

    <!-- Tabela de resultados -->
      <div class="results-table">
        <table mat-table [dataSource]="items" matSort (matSortChange)="announceSortChange($event)">
         <div>
            <ng-container matColumnDef="chk" >
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox (change)="$event ? masterToggle($event) : null" [checked]="selection.hasValue()"
                  [indeterminate]="selection.hasValue()" [hidden]="!params.mult">
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let row">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
                  [checked]="selection.isSelected(row)" [hidden]="!params.mult">
                </mat-checkbox>
              </td>
            </ng-container>
        </div>

          <ng-container matColumnDef="codPosto">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por código">
              Cód. Posto
            </th>
            <td mat-cell *matCellDef="let element"> {{element.codPosto}} </td>
          </ng-container>

          <ng-container matColumnDef="nomePosto">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Ordenar por nome fantasia">
              Nome Posto
            </th>
            <td mat-cell *matCellDef="let element"> {{element.nomePosto}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row
            *matRowDef="let row; columns: displayedColumns; let even = even"
            (click)="detail(row.codPosto, row.nomePosto)"
            class="table-row"></tr>
        </table>
      </div>

      <div class="acoes-botao-selecionar">
        <button mat-button type="button"
                class="btn-fundo-vermelho" (click)="importSelecteds()"
                *ngIf="params.mult"
                [disabled]="selection.selected.length === 0">
          <span> Selecionar Postos</span>
          <!--<mat-icon>add</mat-icon>-->
        </button>
      </div>

      <!-- Paginador centralizado -->
      <div class="paginator-container">
        <mat-paginator
          [pageSizeOptions]="[5,10,20]"
          showFirstLastButtons
          aria-label="Selecione a página de postos">
        </mat-paginator>
      </div>

  </div>
</div>
